import React from 'react'
import { useTranslation } from 'react-i18next'

import { TableRow, TableBody, TableCell } from 'components/Table'
import { TextHighlight } from 'components/TextHighlight/index'
import { redirectToCustomerTimeline } from 'facades/redirectToCustomerTimeline'
import { formatFolderCompletedDate } from 'utils/date'

export const TriageTableContent = ({ data, search = '' }) => {
  const { t } = useTranslation(['formalization'])

  return (
    <TableBody variant="striped">
      {data.map(row => (
        <TableRow
          key={row.applicationID}
          style={{ cursor: 'pointer' }}
          onClick={() => redirectToCustomerTimeline(row.applicationID)}
        >
          <TableCell>
            <TextHighlight text={row.customerName} search={search} />
          </TableCell>
          <TableCell>
            <TextHighlight
              text={t('tables.body.cpf', { cpf: row.customerTaxDocument })}
              search={search}
            />
          </TableCell>
          <TableCell>
            <TextHighlight text={row.consultantName} search={search} />
          </TableCell>
          <TableCell>
            <TextHighlight
              search={search}
              text={
                row.folderCompletedAt === null
                  ? t('tables.body.sla-unknown')
                  : formatFolderCompletedDate(new Date(row.folderCompletedAt))
              }
            />
          </TableCell>
          <TableCell>
            <TextHighlight text={row.status} search={search} />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
